import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#202020"
        d="M14.667 4.8h-8.89v14.4h12.445V8.4h-3.555V4.8zM4 3.893A.89.89 0 014.888 3h10.668L20 7.5v12.594a.91.91 0 01-.256.638.888.888 0 01-.627.268H4.883a.883.883 0 01-.622-.263.905.905 0 01-.261-.63V3.893zm7.111 7.207h1.778v5.4H11.11v-5.4zm0-3.6h1.778v1.8H11.11V7.5z"
      ></path>
    </svg>
  )
}

export default Icon
